import { useRef } from "react";
import { InputProps } from "react-html-props";
import { classes } from "lib/actions/util";
import { Key } from "ts-key-enum";
import SearchSvg from "components/icons/24/tools/tool-search.svg";

export default function InputSearch({
  className,
  placeholder,
  onChange,
  onKeyDown,
  ...rest
}: Omit<InputProps, "onChange"> & {
  onChange(value: string): void;
}) {
  const inputRef = useRef<HTMLInputElement>(null);

  function onChangeHandler(ev: React.ChangeEvent<HTMLInputElement>) {
    onChange?.(ev.target.value);
  }

  function onKeyDownHandler(ev: React.KeyboardEvent<HTMLInputElement>) {
    if (ev.key === Key.Enter) ev.preventDefault();
    onKeyDown?.(ev);
  }

  function clear() {
    if (rest.value === undefined) inputRef.current.value = ""; //if uncontrolled
    onChange?.("");
  }

  return (
    <div className={classes("flex items-center rounded border", className)}>
      <div className="items-center justify-center px-1.5">
        <div className="w-[18px] text-gray-400">
          <SearchSvg />
        </div>
      </div>
      <input
        ref={inputRef}
        className="h-full grow border-none bg-transparent px-0 pr-2 placeholder-gray-400 focus:ring-0"
        type="text"
        placeholder={placeholder ?? "Search"}
        onChange={onChangeHandler}
        onKeyDown={onKeyDownHandler}
        {...rest}
      />
      {inputRef.current?.value && (
        <button
          className="mr-2 flex items-center p-1 text-sm text-gray-500"
          type="button"
          onClick={clear}
        >
          clear
        </button>
      )}
    </div>
  );
}
